<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12 ">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">Contact Reference</h4>
            </div>
        </div>

        <div class="row justify-content-center mt-4 contact-ref-container">
            <div class="col-11 white_box p-4">
                <div class="form-group info-list" style="text-align: left;">
                    <ul>
                        <li>We just need the details of 2 references that we
                            can
                            reach
                            out to if required.​
                        </li>
                        <li>This will not affect their credit score or involve
                            them in
                            your loan.​</li>
                    </ul>
                </div>
                <form [formGroup]="form" (ngSubmit)="submit()">
                    <div formArrayName="contactReferences">
                        <div class="reference-card mb-4" *ngFor="let ref of contactReferences.controls; let i = index"
                            [formGroupName]="i">
                            <div class="reference-header d-flex justify-content-between align-items-center mb-3">
                                <h5 class="ref-title mb-0">Reference {{ i + 1 }}</h5>
                                @if(contactReferences.length > 2){
                                <button type="button" class="btn btn-sm btn-outline-danger remove-btn"
                                    (click)="removeReference(i)" [disabled]="contactReferences.length === 1">
                                    <i class="fa fa-trash"></i> Remove
                                </button>
                                }
                            </div>

                            <div class="row g-4 form-group">
                                <!-- Name -->
                                <div class="col-md-6">
                                    <label class="control-label">Name<span class="text-danger">*</span></label>
                                    <input type="text" formControlName="name" class="form-control"
                                        (keypress)="allowOnlyLetters($event)" placeholder="Enter Full Name" />
                                </div>

                                <!-- Mobile -->
                                <div class="col-md-6">
                                    <label class="control-label">Mobile<span class="text-danger">*</span></label>
                                    <input type="text" formControlName="mobile" class="form-control" minlength="10"
                                        maxlength="10" (keypress)="allowOnlyNumbers($event)"
                                        placeholder="Enter 10-Digit Mobile Number" />
                                </div>

                                <!-- Relation (Dropdown) -->
                                <div class="col-md-6">
                                    <label class="control-label">Relation<span class="text-danger">*</span></label>
                                    <select formControlName="relation" class="form-select">
                                        <option value="" disabled selected>Select Relation</option>
                                        <option *ngFor="let relation of relationTypes" [value]="relation">
                                            {{ relation }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="text-center mt-4">
                        <button type="button" class="btn btn-outline-secondary me-2" (click)="addReference()">
                            + Add Reference
                        </button>
                        @if(form.valid){
                        <button type="submit" class="btn btn-warning px-4" [disabled]="form.invalid">
                            Save & Continue
                        </button>
                        }
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>